export default __webpack_public_path__ + "static/bounty-hunter-bee-43304ffd9a97582612e321760586690f.png";